module.exports = __webpack_public_path__ + "img/flip-1.6b7d1e64.png";